import { ITimeSlot } from "../../Reservation/TimeSlot";
import { TimeSlotKey } from "../../Reservation/TimeSlotKey";

export class CompPackOrderTicketValues {

    constructor(projNr: number, ticketTypeNr: number, poolNr: number, personTypeNr: number, packagePositionNr: number, hasTimeSlots?: boolean, timeSlotKeys?: TimeSlotKey[]) {
        this.projNr = projNr;
        this.ticketTypeNr = ticketTypeNr;
        this.poolNr = poolNr;
        this.personTypeNr = personTypeNr;
        this.packagePositionNr = packagePositionNr;
        this.selectedTimeSlots = [];
        this.hasTimeSlots = hasTimeSlots;
        this.timeSlotKeys = timeSlotKeys;
    }

    projNr: number;
    ticketTypeNr: number;
    poolNr: number;
    personTypeNr: number;
    packagePositionNr: number;
    hasTimeSlots: boolean;
    selectedTimeSlots?: ITimeSlot[];
    timeSlotKeys?: TimeSlotKey[];
}